<template>

  <div>

    <ProductionOrderStepDialog :production-order-batch-step-id="dialogStepDetailId"
                               :only-view="dialogStepDetailOnlyView"
                               @onSubmit="onSubmitOrderStep"
                               @onClose="dialogStepDetailShow = false" v-if="dialogStepDetailShow"/>

    <b-modal size="lg" v-model="modalStockProduct" v-if="modalStockProduct" id="modal-expedition-product-confirm"
             ok-only ok-title="Inserir Ordens" @ok="onInsertFromAutomatically"
             title="Confirmação de Inclusão de Ordens">

      <b-card-title>Qtd. selecionada {{ stockProductIds.length }}/{{ productFind.quantity }}</b-card-title>

      <t-table
          enable-checked
          v-model="stockProductIds"
          :items="stockSourceAutomatically"
          :fields="stockSourceFields"
          title-items="ordens"
          :disable-columns-click="['quantityAvailable','actions']"
          :page-size="10"
          enable-pagination
          link-primary-column="originCodeLabel"
          table-bordered
          disable-actions-column
          primary-key-column="stockProductId">
        <template #first-column="{item}">
          {{ item.originCodeLabel }}
        </template>

        <template #item(quantityAvailable)="{item}">

          <t-input style="max-width: 100px" v-if="item.quantityTotal > 1" v-model="item.quantityAvailable"/>
          <span v-else>-</span>

        </template>

        <template #item(actions)="{item}">

          <b-button
              :to="{path: '/custom/production/order/view/' + item.productionOrderNumber}"
              variant="outline-primary" size="sm" target="_blank">
            <b-icon-box-arrow-up-right class="mr-2"/>
            Detalhar
          </b-button>

        </template>

      </t-table>

      <t-msg info>Ordens de acordo com o perfil do cliente e que não contam nesta ou em outra expedição, mesmo que em
        andamento.
      </t-msg>

    </b-modal>

    <PrintLabelDialog
        @onSubmit="onSubmitPrint" :label-id="1"
        :header-title="'Ordem de Fabricação: ' + dialogPrintLabelProductionOrderCodeLabel"
        :foreignKey="dialogPrintLabelProductionId" foreign-key-column="productionOrderId"/>


    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
                 :status="status"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 primary-key-column="expeditionProductId"
                 @onSubmit="onSubmit" @onItemRead="onItemReadDefault" @onItemDelete="onItemDelete">


      <template #default>

        <t-input v-model="form.expeditionProductId" hidden/>

        <b-col cols="12">

          <div v-if="customerId > 0 && (isInsert || isUpdate)">

            <t-msg info v-if="customerRules.enableAllUnits && customerRules.tolerances.length === 0">Este cliente não
              possui restrições de <b>embalagens</b> ou <b>tolerâncias específicas</b></t-msg>

            <t-msg warning v-else>
              Este cliente possui restrições:
              <ul class="mb-0">
                <li v-if="!customerRules.enableAllUnits"><b>Unidades aceitas:</b> {{ customerRulesUnits }}</li>
                <li v-if="customerRules.tolerances.length > 0"><b>Tolerâncias restritas:</b>
                  {{ customerRulesTolerances }}
                </li>
              </ul>
            </t-msg>


          </div>

          <!--
              Será utilizado neste padrão em outros clientes
              <b-row>

                   <b-col cols="6">

                     <t-input-product v-model="form.productId"/>

                   </b-col>

                   <b-col cols="6">

                     <t-input-search cols="8" v-model="form.stockPlaceProductInsideId" :options="stockPlaceProductInsideOptions"
                                     label="Local de Armazenamento" select/>

                   </b-col>

                 </b-row>-->

          <t-form-card v-if="formatInsert === 'M'" title="Inserir manualmente">

            <template #icon>
              <b-icon-plus-circle></b-icon-plus-circle>
            </template>

            <b-row>

              <b-col class="col-md-8 col-sm-12">

                <b-row>



                  <t-input cols="8" label="Nº Ordem de Fabricação" iid="inputCodeLabel" @focusout="checkQuantity()"
                           v-model="searchByCodeLabel" :add-error="error.stockProductId" required
                           @focusin="getSourceManually"
                           @keydown.native="executeSearchByCodeLabel"
                           small="0000/ANO ou 0000 e pressione Enter" highlight/>

                  <t-input cols="4" label="Qtd." iid="inputQuantity" :disabled="form.quantity === 1"
                           v-model="form.quantity"
                           :add-error="error.quantity" required
                           help="Utilizado por enquanto somente em Sacarias de 25Kg, onde deverá especificar a quantidade de sacos vendidos do Pallet que por padrão são 20."/>

                </b-row>

                <t-input v-model="productName" label="Produto" fixed/>
                <!-- <t-input label="Produto"  v-model="form.stockProductId" required select :add-error="error.stockProductId"
                                     :options="stockProductOptions"/>-->

              </b-col>

              <b-col cols="4" class="button-form-inline col-md-4 col-sm-12">

                <t-button :sending="status === 'sending'" :text="onButtonSubmitText(command)" no-icon submit/>

                <b-link class="ml-2 text-focus" v-if="command === 'update'" @click="cancelUpdatedList()">
                  {{ t('go-back') }}
                </b-link>

              </b-col>

            </b-row>

          </t-form-card>

          <div v-else>

            <t-form-card class="mt-4" title="Buscar automaticamente">

              <template #icon>
                <b-icon-basket></b-icon-basket>
              </template>

              <div class="col-12">

                <t-button icon-search v-show="!showSearchProduct" @click="showSearchProduct = true"
                          text="Buscar Ordens"/>

                <b-row v-show="showSearchProduct">

                  <b-col cols="6">

                    <t-input
                        v-model="productFind.materialId"
                        :options="materialOptions"
                        radio

                        label="Material" required/>

                  </b-col>

                  <b-col cols="6">

                    <t-input v-model="productFind.modelId" :options="modelOptions"
                             radio
                             label="Tipo" required/>

                  </b-col>

                </b-row>

                <b-row v-show="showSearchProduct">

                  <t-input cols="3" v-model="productFind.groupProductId"
                           :options="groupProductOptions"
                           select

                           label="Grupo" required/>


                  <t-input cols="3" v-model="productFind.unitId"
                           :options="unitOptions"
                           select :small="!customerRules.enableAllUnits ? 'Somente aceitas pelo cliente' : ''"
                           label="Embalagem" required/>


                  <t-input cols="3" label="Qtd. desejada"
                           v-model="productFind.quantity"
                           required
                  />

                  <b-col cols="3" class="button-form-inline">

                    <t-button icon-search @click="findSourceByProduct" text="Buscar Ordens"/>

                  </b-col>

                </b-row>

              </div>

            </t-form-card>

          </div>

          <t-form-card class="mt-4" title="Total por Grupo Produto">

            <template #icon>
              <b-icon-receipt></b-icon-receipt>
            </template>

            <b-table :items="listTotals" :busy="!pageFormIsLoaded"
                     :fields="totalsFields">

              <template #cell(totalProducedWeight)="{item}">
                <b>{{ item.totalProducedWeight | number }} Kg</b>
              </template>


            </b-table>

          </t-form-card>


        </b-col>

      </template>


      <template #item(productName)="{item}">

        <div>{{ item.productName }}</div>

        <small v-if="item.manualInsert" class="text-warning">
          <b-icon-exclamation-circle-fill style="font-size: 0.9em;"></b-icon-exclamation-circle-fill>
          Inserção Manual
          <t-help
              :title="getOriginTextInsert(item)"/>
        </small>

        <small v-else class="text-success">
          <b-icon-check-circle-fill style="font-size: 0.9em;"></b-icon-check-circle-fill>
          Inserção Autom&aacute;tica
          <t-help
              :title="getOriginTextInsert(item)"/>
        </small>


      </template>


      <template #item(appendActions)="{item}">

        <div class="mt-1">

          <t-button small @click="openDialogPrintLabelProduction(item.productionOrderId,item.originCodeLabel)">Etiqueta
            Qualidade
          </t-button>

          <t-button class="ml-2" @click="openDialogStepDetail(item.request_final_inspection_step_id,false)" small
                    warning
                    v-show="item.request_final_inspection_necessary && item.request_final_inspection_status === 1">
            Inspeção Pendente
          </t-button>

          <t-button class="ml-2" @click="openDialogStepDetail(item.request_final_inspection_step_id,true)" small success
                    v-show="item.request_final_inspection_necessary && item.request_final_inspection_status === 2">
            <b-icon-check/>
            Inspeção Realizada
          </t-button>

          <t-button class="ml-2" @click="openDialogStepDetail(item.request_final_inspection_step_id,true)" small danger
                    v-show="item.request_final_inspection_necessary && item.request_final_inspection_status === 3">
            Inspeção Reprovada
          </t-button>


        </div>


      </template>


    </t-form-list>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"
import StockItemType from "@/model/types/modules/stock/StockItemType";
import StockProductService from "@/services/modules/stock/StockProduct.service";
import ExpeditionService from "@/services/modules/stock/Expedition.service";

import http from "@/services/config/http-common"
import ui from "@/assets/scripts/ui";
import PrintLabelDialog from "@/views/modules/general/PrintLabelDialog";
import ProductionOrderStepDialog
  from "@/views/modules/production/ProductionOrder/dialog/ProductionOrderStepDialog";
import ProductService from "@/services/modules/product/Product.service";
import UnitService from "@/services/modules/product/Unit.service";
import ModelService from "@/services/modules/product/Model.service";
import MaterialService from "@/services/modules/product/Material.service";
import groupProduct from "@/views/modules/product/GroupProduct.vue";
import GroupProductService from "@/services/modules/product/GroupProduct.service";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {tFormList, ProductionOrderStepDialog, PrintLabelDialog},
  name: 'ExpeditionOrderProduct',
  data() {
    return {
      StockItemType,
      path: "stock/expedition-order-product", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "expeditionId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        /*ESPECIFICO PARA POLIMIX*/
        {keyRead: "expeditionProductId", keyDelete: "expeditionProductId"},
        {key: "originCodeLabel", label: "Bag", cols: "2"},
        {key: "productionIssueDate", label: "Emissão", cols: "3", formatter: "date"},
        {key: "productName", label: "Produto", cols: "3"},
        {key: "quantity", label: "Qtd.", cols: "2"},
        {key: "producedWeight", label: "Peso", formatter: "weightKg", cols: "2"},
        {key: "appendActions", label: "", formatter: "", cols: "12"},
      ],
      totalsFields: [
        {key: "groupProduct", label: "Grupo"},
        {key: "unit", label: "Forma Física"},
        {key: "model", label: "Modelo"},
        {key: "totalQuantity", label: "Qtd. Itens"},
        {key: "totalProducedWeight", label: "Peso Total", variant: "info"},
      ],
      form: {
        expeditionId: this.foreignKey,
        expeditionProductId: 0,
        stockProductId: 0,
        quantity: 1,
        manualInsert: true,
        note: "",
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        stockProductId: "",
      },
      modalStockProduct: false,
      stockSourceManually: [],
      stockSourceAutomatically: [],
      stockProductOptions: [],
      stockProductIds: [],
      stockSourceFields: [
        {key: "originCodeLabel", label: "OF"},
        {key: "productName", label: "Produto"},
        {key: "producedWeight", label: "Peso", formatter: "weightKg"},
        {key: "productionIssueDate", label: "Emissão", formatter: "date"},
        {
          key: "quantityAvailable",
          label: "Qtd. Fracionada",
          formatter: "number",
          help: "Utilizado por enquanto somente em Sacarias de 25Kg, onde deverá especificar a quantidade de sacos vendidos do Pallet que por padrão são 20."
        },
        {key: "actions", label: "Detalhar"},
      ],
      searchByCodeLabel: "",
      productName: "",
      listTotals: [],
      showSearchProduct: false,
      dialogStepDetailShow: false,
      dialogStepDetailId: 0,
      dialogStepDetailOnlyView: true,
      dialogPrintLabelProductionOrderCodeLabel: "",
      dialogPrintLabelProductionId: 0,
      modelOptions: [],
      unitOptions: [],
      materialOptions: [],
      groupProductOptions: [],
      tolerancesIds: "",
      productFind: { /*Campos utilizados para buscar produto*/
        productId: 0,
        groupProductId: 0,
        modelId: 0,
        unitId: 0,
        materialId: 0,
        groupProduct: "",
        quantity: null,

      },

    }
  },
  props: {
    /*Utilizada quando o formulário se torna um objeto Embeddable*/
    customerRulesUnits: String,
    customerRulesTolerances: String,
    customerRules: {
      type: Object,
      default: null
    },
    customerId: Number,
    formatInsert: {
      type: String,
      default: "A",
    },
  },
  computed: {
    groupProduct() {
      return groupProduct
    },
    onForm() {
      return this.form
    }
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()

      /*PADRÃO POLIMIX*/
      this.form.quantity = 1

      this.productName = ''

      if (this.formatInsert === 'M')
        ui.focusById('inputCodeLabel')

      this.getTotals()

    },

    mountedPrepare() {

      this.listParams.append('sorted', 'originCodeLabel')
      this.mountedPrepareFormListDefault()

    },

    async mountedContinued(focus = true) {

      await this.getList()

      await this.getTotals()

      await ModelService.selectList().then((response) => {
        this.modelOptions = response
      }).catch(error => this.responseError(error))

      await MaterialService.selectList().then((response) => {
        this.materialOptions = response
      }).catch(error => this.responseError(error))

      await GroupProductService.selectList().then((list) => {
        this.groupProductOptions = list
      }).catch(error => this.responseError(error))

      if (this.objValid(this.customerRules.tolerances) && this.customerRules.tolerances.length > 0) {

        this.tolerancesIds = this.customerRules.tolerances
            .map(item => item.processFlowStepRuleId)
            .join('|')


        const groupProductOriginal = this.groupProductOptions
        this.groupProductOptions = []

        const materialOriginal = this.materialOptions
        this.materialOptions = []

        const modelOriginal = this.modelOptions
        this.modelOptions = []


        //Deverá restringir os modelos somente se existir
        for(let tolerance of this.customerRules.tolerances) {

          let optionGroup = groupProductOriginal.find(a => a.value === tolerance.groupProductId)
          if (optionGroup && !this.groupProductOptions.some(a => a.value === optionGroup.value)) {
            this.groupProductOptions.push(optionGroup)
          }

          if (tolerance.materials && Array.isArray(tolerance.materials)) {

            tolerance.materials.forEach(material => {

              let optionMaterial = materialOriginal.find(a => a.value === material.materialId)

              if (
                  optionMaterial &&
                  !this.materialOptions.some(a => a.value === optionMaterial.value)
              ) {
                this.materialOptions.push(optionMaterial)
              }

            })

          }


          if (tolerance.models && Array.isArray(tolerance.models)) {

            tolerance.models.forEach(model => {

              let optionModel = modelOriginal.find(a => a.value === model.modelId)

              if (
                  optionModel &&
                  !this.modelOptions.some(a => a.value === optionModel.value)
              ) {
                this.modelOptions.push(optionModel)
              }

            })

          }



        }

        if(this.groupProductOptions.length === 1) {
          this.productFind.groupProductId = this.groupProductOptions[0].value
        }


        if(this.materialOptions.length === 1) {
          this.productFind.materialId = this.materialOptions[0].value
        }

        if(this.modelOptions.length === 1) {
          this.productFind.modelId = this.modelOptions[0].value
        }

      }

      await UnitService.selectList().then((response) => {

        this.unitOptions = response

        if (this.objValid(this.customerRules.units) && !this.customerRules.enableAllUnits) {

          // Cria um Set com os unitId permitidos para o cliente
          const restrictedUnitIds = new Set(
              this.customerRules.units.map(unit => unit.unitId)
          )

          // Remove da listagem as unidades que est&atilde;o nas regras do cliente
          this.unitOptions = this.unitOptions.filter(
              unit => restrictedUnitIds.has(unit.value)
          )

          if(this.unitOptions.length === 1) {
            this.productFind.unitId = this.unitOptions[0].value
          }

        }

      }).catch(error => this.responseError(error))



      if (focus)
        ui.focusById('inputCodeLabel')

    },

    async onSubmit() {

      this.form.stockProductId = 0

      //Valida o código informado
      const item = this.stockProductOptions.find(a => a.text === this.searchByCodeLabel)

      if (item !== null && item !== undefined) {
        ///Encontrado com sucesso!

        this.form.stockProductId = item.value
        this.form.manualInsert = true

        await this.setSending(
            this.form.expeditionProductId,
            async () => {
              await this.actionDefaultAfterCRUD()
              ui.toast(this, "Inserido", "Nº Bag <b>" + this.searchByCodeLabel + "</b> inserido com sucesso!", "success", "b-toaster-top-center", true)
              this.searchByCodeLabel = ''
            },
            () => {
              this.actionDefaultAfterCRUD()
            }, () => {
              this.actionDefaultAfterCRUD()
            },
        )


      } else {
        ui.msgError(this, "Nº de bag <b>" + this.searchByCodeLabel + "</b> não encontrado ou não está disponível para expedição")
      }

    },

    mountedList() {

      this.removeSourceUtilized()
      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    executeSearchByCodeLabel(event) {
      if (event.which === 13 && this.searchByCodeLabel !== '') {

        //Padroniza o tamano inicial do bag
        if (this.searchByCodeLabel.length < 4) {
          this.searchByCodeLabel = ui.lpad(this.searchByCodeLabel, 4)
        }

        if (this.searchByCodeLabel.length === 4) {
          this.searchByCodeLabel += "/" + ui.currentYear()
        }

        this.checkQuantity()

        if (this.form.quantity > 1) {
          ui.focusById('inputQuantity')
        } else {
          this.onSubmit()
        }

      }

    },

    checkQuantity() {

      if (this.searchByCodeLabel !== '') {

        //Valida o código informado
        const option = this.stockProductOptions.find(a => a.text === this.searchByCodeLabel)

        if (option !== null && option !== undefined) {

          const stockProductId = option.value

          const item = this.stockSourceManually.find(a => a.stockProductId === stockProductId)
          this.form.quantity = item.quantityAvailable
          this.productName = item.productName

        }

      }

    },


    removeSourceUtilized() {
      //Removerá das opções da listagem os itens já inseridos aqui nesta Ordem de Expedição
      for (const item of this.items) {

        const indexRemove = this.stockProductOptions.findIndex(a => a.value === item.stockProductId)

        if (indexRemove >= 0)
          this.stockProductOptions.splice(indexRemove, 1)

      }
    },

    onItemDelete(id) {

      this.onItemDeleteDefault(id, () => {


      })

    },


    async getTotals() {

      await ExpeditionService.getTotalsById(this.foreignKey).then(response => this.listTotals = response)

    },

    async getSourceManually(productId = 0, stockPlaceProductInsideId = 0) {

      await StockProductService.findSource(productId, stockPlaceProductInsideId, "originCodeLabel", true).then(response => {

        this.stockSourceManually = response
        this.stockProductOptions = []

        /*ESPECIFICO DA POLIMIX, DESMEMBRAR NO EMBEDDABLE*/
        for (const item of this.stockSourceManually) {

          this.stockProductOptions.push({
            value: item.stockProductId,
            text: item.originCodeLabel
          })

        }

        this.removeSourceUtilized()

      })

    },

    openDialogPrintLabelProduction(productionOrderId, productionOrderCodeLabel) {
      this.dialogPrintLabelProductionId = productionOrderId
      this.dialogPrintLabelProductionOrderCodeLabel = productionOrderCodeLabel
      this.openDialogForm('modal-print-label-1')
    },

    async onSubmitPrint() {
      ui.toast(this, 'Impressão enviada', 'Impressão enviada com sucesso!')
    },

    async onSubmitOrderStep(response) {

      ui.toast(this, 'Informação', 'Inspeção realizada na OF ' + response.productionOrderCodeLabel + '!')

      await this.mountedContinued(false)

    },

    openDialogStepDetail(id, onlyView) {

      this.dialogStepDetailShow = true
      this.dialogStepDetailId = id
      this.dialogStepDetailOnlyView = onlyView

      this.openModal('modal-production-order-step-detail')

    },

    async findProductByPolimixParams() {

      let success = false
      let params = new URLSearchParams()
      params.set("groupProductId", this.productFind.groupProductId)
      params.set("unitId", this.productFind.unitId)
      params.set("modelId", this.productFind.modelId)
      params.set("materialId", this.productFind.materialId)

      await ProductService.selectList(params).then((options) => {

        if (options !== null) {

          if (options.length === 1) {
            this.productFind.productId = options[0].value
            success = true
          } else if (options.length === 0) {
            ui.msgError(this, "Produto relacionado ao grupo, unidade de medida e embalagem (un. medida) não foi encontrado e não será possível continuar. Verifique com a Qualidade se algum modelo/produto foram alterados")
          } else {
            ui.msgError(this, "Inconsistência com mais que um produto relacionado ao grupo, unidade de medida e embalagem (un. medida) e não será possível continuar. Verifique com a Qualidade se algum modelo/produto foram alterados")
          }
        }

      }).catch(error => this.responseError(error))

      return success

    },

    async findSourceByProduct() {

      if (this.productFind.groupProductId !== 0 &&
          this.productFind.unitId !== 0 &&
          this.productFind.modelId !== 0 &&
          this.productFind.materialId !== 0 &&
          this.productFind.quantity > 0) {

        const checkProduct = await this.findProductByPolimixParams()

        if (checkProduct) {

          await StockProductService.findSource(this.productFind.productId, 0, "productionIssueDate", true, "Y", this.form.expeditionId, this.customerId).then(response => {

            this.stockSourceAutomatically = response


            for (const item of this.items) {

              const indexRemove = this.stockSourceAutomatically.findIndex(a => a.value === item.stockProductId)

              if (indexRemove >= 0)
                this.stockSourceAutomatically.splice(indexRemove, 1)

            }


            if (this.stockSourceAutomatically.length > 0) {

              this.stockProductIds = []
              this.modalStockProduct = true

              for (let i = 0; i < this.productFind.quantity; i++) {
                if (this.stockSourceAutomatically.length > i)
                  this.stockProductIds.push(this.stockSourceAutomatically[i].stockProductId)
              }

              this.openModal('modal-expedition-product-confirm')

            } else {
              ui.msgError(this, 'Não foram encontrados itens no estoque de acordo com o perfil do cliente e produto desejado')
            }

          })

        }

      } else {

        ui.msgError(this, "Selecione todos os campos para busca de produtos no estoque")

      }


    },


    async getResumeProduct(productId) {

      await ProductService.getResume('id', productId)
          .then(resume => {

            this.productFind.groupProductId = resume.groupProductId
            this.productFind.modelId = resume.modelId
            this.productFind.unitId = resume.unitId
            this.productFind.modelId = resume.modelId
            this.productFind.materialId = resume.materialId


          })

    },

    async onInsertFromAutomatically() {


      if (this.stockProductIds.length > 0) {


        const selectedStockIds = new Set(this.stockProductIds);

        //Adicionar todos como true
        this.stockSourceAutomatically = this.stockSourceAutomatically.map(item => ({
          ...item,
          manualInsert: true
        }));


        /*Marca os primeiros como selecionados automaticamente, mesmo que estes não tenham sido selecionados para inclusão*/
        for (let i = 0; i < this.productFind.quantity; i++) {
          if (this.stockSourceAutomatically.length > i)
            this.stockSourceAutomatically[i].manualInsert = false
        }

        /*Filtra somente os selecionados*/
        const result = this.stockSourceAutomatically
            .filter(item => selectedStockIds.has(item.stockProductId))
            .map(item => ({
              stockProductId: item.stockProductId,
              quantity: item.quantityAvailable,
              originCodeLabel: item.originCodeLabel,
              manualInsert: item.manualInsert
            }))


        this.pageFormIsLoaded = false

        await http.post("/stock/expedition-order-product/saveByList/" + this.form.expeditionId, result).then(async (response) => {

          this.pageFormIsLoaded = true
          await this.getList()
          await this.getTotals()

          const errors = response.data.filter(item => item.success === false);

          let errorMessageHtml = '';

          if (errors.length > 0) {
            errorMessageHtml =
                '<b>Problemas identificados nas seguintes ordens:</b>' +
                '<ul>' +
                errors
                    .map(item => {
                      const originLabel = item.originCodeLabel
                          ? item.originCodeLabel
                          : 'Ordem não identificada';

                      return `<li><b>${originLabel}</b> - ${item.errorMessage}</li>`;
                    })
                    .join('') +
                '</ul>';

            ui.msgError(this, errorMessageHtml)


          } else {

            ui.toast(this, 'Informação', 'Ordens inseridas com sucesso!')
            this.modalStockProduct = false
            this.stockProductIds = []

          }


        }).catch(error => ui.generalResponseError(this, error))

        this.pageFormIsLoaded = true

      } else {
        ui.msgError(this, "Selecione pelo menos 1(uma) ordem que deseja inserir")
      }

    },

    getOriginTextInsert(item) {

      const createdDate = ui.convertDateBR(item.logControl.createdDate, true)

      if (item.manualInsert) {
        return `Inclusão realizada em <b>${createdDate}</b> por <b>${item.logControl.createdUser}</b> de forma manual.`
      } else {
        return `Inclusão realizada em <b>${createdDate}</b> por <b>${item.logControl.createdUser}</b> de forma automática, conforme escolha do sistema, com base nos critérios do perfil do cliente e na ordem de emissão (FIFO).`
      }

    }

    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
